import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { WindowProxy } from '@sm360/widget-commons-core-services';

import CONSTANT from 'login/constants/constant.js';

import 'login/components/Banners/MessageBanner.scss';

class MessageBanner extends React.Component {
    constructor(props) {
        super(props);

        this.showMessage = this.showMessage.bind(this);
        this.dismissMessage = this.dismissMessage.bind(this);
    }

    componentWillMount() {
        this.showMessage(this.props.text);
    }

    shouldComponentUpdate(newProps) {
        if (!isEqual(newProps, this.props)) {
            this.showMessage(newProps.text);
            return true;
        }

        return false;
    }

    showMessage(bannerText) {
        if (bannerText && WindowProxy.get()) {
            WindowProxy.get().document.body.classList.add('message-drop-animation');
        }
    }

    dismissMessage() {
        if (WindowProxy.get()) {
            WindowProxy.get().document.body.classList.remove('message-drop-animation');
        }
    }

    render() {
        const showSuccessBanner = this.props.level === CONSTANT.MESSAGE.LEVELS.SUCCESS;
        const bannerClass = showSuccessBanner ? 'success' : 'error';
        // const iconClass = showSuccessBanner ? 'icon-round-check' : 'icon-cancel';

        return (
            !!this.props.text && (
                <div className={['message-banner', bannerClass].join(' ')}>
                    <div className="row collapse message">
                        {/* <span className={iconClass} /> */}
                        <p className="message-content">{this.props.text}</p>
                        <icon className="message-close" onClick={this.dismissMessage} />
                    </div>
                </div>
            )
        );
    }
}

MessageBanner.propTypes = {
    text: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
};

MessageBanner.displayName = 'MessageBanner';

export default MessageBanner;
